<script>
import SubTableEffContract from "./SubTableEffContract.vue";
import {getPersonEffectiveContracts} from "../../utils/api/personEffectiveContract.api.service";
import ApiServices from "../../../services/api.services";
import EffContractUmuCommentFormDialog from "./EffContractUmuCommentFormDialog.vue";
import EffectiveContractAutoCalculationDetailDialog
  from "../../../Dialog/EffectiveContractAutoCalculationDetailDialog.vue";

export default {
  name: "EffContractUMUDetailDialog",
  components: {EffectiveContractAutoCalculationDetailDialog, EffContractUmuCommentFormDialog, SubTableEffContract},

  props: {
    effContractOrderId: {
      type: Number,
      default: null,
    },

    effConOrder: {
      type: Object,
      default: null,
    },

    dialog: {
      type: Boolean,
      required: true
    }
  },

  watch: {
    dialog: function () {
      if (this.dialog) {
        if (this.effConOrder) {
          this.getPersonEffContracts();
        }
      } else {
        this.personEffContracts = [];
      }
    }
  },

  data() {
    return {
      personEffContracts: [],

      showEffContractComment: false,
      personEffContractId: null,

      autoCalculateDetailDialog: false,
    }
  },

  computed: {
    fullName() {
      if(_.isEmpty(this.effConOrder) || _.isNil(this.effConOrder)) return ""

      const fullName = this.effConOrder?.full_name;
      const arrayFullName = fullName.split(" ")
      let formattedFullName = arrayFullName[0] + " " + arrayFullName[1]

      if (formattedFullName.length > 2) {
        formattedFullName += " " + arrayFullName[2][0] + "."
      }

      return formattedFullName;
    },

    degree() {
      if(_.isEmpty(this.effConOrder) || _.isNil(this.effConOrder)) return ""
      return this.effConOrder?.teacher_eff_order?.academic_title || "Пусто";
    },

    headDepartment() {
      if(_.isEmpty(this.effConOrder) || _.isNil(this.effConOrder)) return false

      return this.effConOrder?.teacher_eff_order?.head_department || false;
    },

    dean() {
      if(_.isEmpty(this.effConOrder) || _.isNil(this.effConOrder)) return ""

      return this.effConOrder?.teacher_eff_order?.dean || false;
    },

    bid() {
      if(_.isNil(this.effConOrder)) return ""

      const bid = this.effConOrder?.teacher_eff_order?.bid;

      if(_.isNil(bid)) return "Пусто"

      if (Number(bid) === 1.00) {
        return `Полная`
      } else {
        return `Неполная (${bid})`
      }
    }
  },

  methods: {

    async getPersonEffContracts() {
      const [data, error] = await getPersonEffectiveContracts(this.effConOrder.teacher_eff_order.id)

      if (error) {
        return console.log(error)
      }
      this.personEffContracts = data.person_eff_contracts;
    },

    async sendStatusContractPerson(id, statusContract) {
      try {
        const response = await ApiServices.confirmContractPersonContract(id, statusContract);
        this.personEffContracts = response.data.person_eff_contracts;
      } catch (e) {
        console.log(e);
      }
    },


    close() {
      this.$emit("close", this.personEffContracts)
    },

    setRemarkToContract(id, status) {
      if (status === 'has_remark') {
        this.sendStatusContractPerson(id, 'has_remark');
      } else {
        this.openEffContractCommentFormDialog(id);
      }
    },

    openEffContractCommentFormDialog(personEffContractId) {
      this.showEffContractComment = true;
      this.personEffContractId = personEffContractId;
    },

    closeEffContractCommentFormDialog() {
      this.showEffContractComment = false;
      this.personEffContractId = null;
    },

    openAutoCalculateDetailDialog(id) {
      this.autoCalculateDetailDialog = true;
      this.personEffContractId = id;
    },

    closeAutoCalculateDetailDialog() {
      this.autoCalculateDetailDialog = false;
      this.personEffContractId = null;
      this.personId = null;
    }
  }
}
</script>

<template>
  <v-dialog
    :value="dialog"
    content-class="v-dialog-right rounded-xl"
    transition="slide-x-reverse-transition"
    width="55vw"
    persistent
  >

    <effective-contract-auto-calculation-detail-dialog
      :dialog="autoCalculateDetailDialog"
      :person-eff-contract-id="personEffContractId"
      :person-id="effConOrder.id"
      @close="closeAutoCalculateDetailDialog"
    />

    <eff-contract-umu-comment-form-dialog
      :show="showEffContractComment"
      :person-eff-contract-id="personEffContractId"
      @close="closeEffContractCommentFormDialog"
      @remark="sendStatusContractPerson"
    />

    <v-card class="fill-height rounded-xl">
      <v-toolbar elevation="0">
        <v-toolbar-title>
          Эффективный контракт
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="close"
        >
          <v-icon>
            fa-times
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-row>
          <v-col cols="5" class="d-flex align-center">
            <v-sheet>
              <p class="pa-0 ma-0 text-body-1">Предоставил</p>
              {{fullName}}
            </v-sheet>
          </v-col>
          <v-col cols="7">
            <v-sheet class="text-body-1">
              <p class="pa-0 ma-0 mb-1">Должность: {{degree}}</p>
              <p class="pa-0 ma-0 mb-1">Ставка: {{bid}}</p>
              <p class="pa-0 ma-0 mb-1">
                Декан: {{dean ? "Да" : "Нет"}}
                <v-icon x-small left :color="dean ? 'teal darken-3' : 'red'">fa-circle</v-icon>
              </p>
              <p class="pa-0 ma-0 mb-1">
                Зав. кафедрой: {{headDepartment ? "Да" : "Нет"}}
                <v-icon x-small left :color="headDepartment ? 'teal darken-3' : 'red'">fa-circle</v-icon>
              </p>
            </v-sheet>
          </v-col>
        </v-row>
      </v-card-title>
      <v-sheet width="100%" class="px-6">
        <v-divider/>
      </v-sheet>
      <v-card-text>
        <sub-table-eff-contract
          :teacher="effConOrder"
          :eff-contracts-by-person="personEffContracts"
          :loading="false"
          @confirmed="sendStatusContractPerson"
          @remark="setRemarkToContract"
          @editFact="getPersonEffContracts"
          :dialog="dialog"
          @openAutoDetailDialog="openAutoCalculateDetailDialog"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
>>> .v-dialog-right {
  position: absolute;
  border-radius: 0;
  margin: 0;
  padding: 0;
  height: 98vh;
  min-height: 98vh;
  overflow-y: auto;
  top: auto;
  right: 20px;
}
</style>